import { useState } from 'react';

export type DuplicationFormState = {
    excludedAgentDepartureHypotheses: number[];
    excludedAgentArrivalHypotheses: number[];
    excludedMantyStatusHypotheses: number[];
    excludedPayComponentHypotheses: number[];
    excludedAgentPayComponentHypotheses: number[];
    excludedGradeAdvancementHypotheses: number[];
};

export function useDuplicationFormState(
    initialState: DuplicationFormState,
): [
    DuplicationFormState,
    React.Dispatch<React.SetStateAction<DuplicationFormState>>,
] {
    return useState(initialState);
}
